import { render } from "./AsyncImage.vue?vue&type=template&id=0766fc60&ts=true"
import script from "./AsyncImage.vue?vue&type=script&lang=ts"
export * from "./AsyncImage.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__